/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddressBookListResponse } from '../../models/address-book-list-response';
import { BaseResponse } from '../../models/base-response';

export interface OfficeControllerFindAllAddressBookByOffice$Params {
  id: number;
  limit?: number;
  skip?: number;
}

export function officeControllerFindAllAddressBookByOffice(http: HttpClient, rootUrl: string, params: OfficeControllerFindAllAddressBookByOffice$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AddressBookListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, officeControllerFindAllAddressBookByOffice.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AddressBookListResponse;
      }>;
    })
  );
}

officeControllerFindAllAddressBookByOffice.PATH = '/company/office/addressbook/office/{id}';
